/* PRIME DIGITAL GOODS — global.js */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* ---- Header shadow on scroll ---- */
    var header = document.querySelector('[data-header]');
    if (header) {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    /* ---- Mobile drawer (focus-managed) ---- */
    var drawer = document.querySelector('[data-drawer]');
    var overlay = document.querySelector('[data-overlay]');
    var openers = document.querySelectorAll('[data-drawer-open]');
    var closers = document.querySelectorAll('[data-drawer-close]');
    var lastFocused = null;

    function setDrawerClosed(closed) {
      if (!drawer) return;
      drawer.classList.toggle('is-open', !closed);
      if (overlay) overlay.classList.toggle('is-open', !closed);
      document.body.classList.toggle('no-scroll', !closed);
      drawer.setAttribute('aria-hidden', closed ? 'true' : 'false');
      if ('inert' in drawer) drawer.inert = closed;
      openers.forEach(function (b) { b.setAttribute('aria-expanded', closed ? 'false' : 'true'); });
    }
    function openDrawer() {
      if (!drawer) return;
      lastFocused = document.activeElement;
      setDrawerClosed(false);
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    function closeDrawer() {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      setDrawerClosed(true);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }
    if (drawer) setDrawerClosed(true);
    openers.forEach(function (b) { b.addEventListener('click', openDrawer); });
    closers.forEach(function (b) { b.addEventListener('click', closeDrawer); });
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
      /* keep tab focus inside the drawer while it is open (fallback when inert is unsupported) */
      if (e.key === 'Tab' && drawer && drawer.classList.contains('is-open') && !('inert' in drawer)) {
        var focusables = drawer.querySelectorAll('a[href], button:not([disabled])');
        if (!focusables.length) return;
        var firstEl = focusables[0];
        var lastEl = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
        else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
      }
    });

    /* ---- FAQ accordion ---- */
    var faqItems = document.querySelectorAll('[data-faq-item]');
    faqItems.forEach(function (item, i) {
      var btn = item.querySelector('[data-faq-q]');
      var ans = item.querySelector('[data-faq-a]');
      if (!btn || !ans) return;
      if (!ans.id) ans.id = 'faq-panel-' + (i + 1);
      btn.setAttribute('aria-controls', ans.id);
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        var parent = item.parentElement;
        if (parent) {
          parent.querySelectorAll('[data-faq-item].is-open').forEach(function (other) {
            if (other !== item) {
              other.classList.remove('is-open');
              var oa = other.querySelector('[data-faq-a]');
              var ob = other.querySelector('[data-faq-q]');
              if (oa) oa.style.maxHeight = null;
              if (ob) ob.setAttribute('aria-expanded', 'false');
            }
          });
        }
        if (isOpen) {
          item.classList.remove('is-open');
          ans.style.maxHeight = null;
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          ans.style.maxHeight = ans.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* ---- Smooth scroll for in-page anchors ---- */
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        var target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          var top = target.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
          closeDrawer();
        }
      });
    });

    /* ---- Scroll reveal ---- */
    var reveals = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && reveals.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* ---- Product thumbnails (buttons, keyboard accessible) ---- */
    var thumbs = document.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var main = document.querySelector('[data-product-main-img]');
        if (!main) return;
        var full = thumb.getAttribute('data-full');
        var fullSet = thumb.getAttribute('data-full-srcset');
        if (full) main.src = full;
        if (fullSet) { main.setAttribute('srcset', fullSet); } else { main.removeAttribute('srcset'); }
        var img = thumb.querySelector('img');
        if (img && img.alt) main.alt = img.alt;
        thumbs.forEach(function (t) {
          t.classList.toggle('is-current', t === thumb);
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });

    /* ---- Variant selector: keep form id + price in sync ---- */
    document.querySelectorAll('[data-product-form]').forEach(function (wrap) {
      var dataEl = wrap.querySelector('[data-variants]');
      var idInput = wrap.querySelector('input[name="id"]');
      var selects = wrap.querySelectorAll('[data-option-select]');
      var addBtn = wrap.querySelector('[data-add-to-cart]');
      var priceEl = document.querySelector('[data-product-price]');
      if (!dataEl || !idInput || !selects.length) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var currency = wrap.getAttribute('data-currency') || 'USD';
      var addLabel = addBtn ? addBtn.textContent : '';
      var soldOutLabel = wrap.getAttribute('data-soldout-label') || 'Sold out';

      function formatMoney(cents) {
        try {
          return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
        } catch (err) { return (cents / 100).toFixed(2); }
      }
      function currentVariant() {
        var chosen = [];
        selects.forEach(function (s) { chosen[parseInt(s.getAttribute('data-option-select'), 10) - 1] = s.value; });
        return variants.find(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        });
      }
      function sync() {
        var v = currentVariant();
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = soldOutLabel; }
          return;
        }
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? addLabel : soldOutLabel;
        }
      }
      selects.forEach(function (s) { s.addEventListener('change', sync); });
      sync();
    });

  });
})();
